import { z } from "zod";
import { NATUREZAS, TIPOS_FINANCEIROS, type NaturezaDoCusto, type TipoFinanceiro } from "./lancamento";

/** Criadas no primeiro acesso ao financeiro; a organização pode renomear e criar outras. */
export const CATEGORIAS_PADRAO: { nome: string; tipo: TipoFinanceiro; natureza: NaturezaDoCusto; cor: string }[] = [
  { nome: "Serviços de prótese", tipo: "ENTRADA", natureza: "VARIAVEL", cor: "#10b981" },
  { nome: "Outras receitas", tipo: "ENTRADA", natureza: "VARIAVEL", cor: "#14b8a6" },
  { nome: "Aluguel", tipo: "SAIDA", natureza: "FIXO", cor: "#6366f1" },
  { nome: "Salários e encargos", tipo: "SAIDA", natureza: "FIXO", cor: "#2457ff" },
  { nome: "Energia e água", tipo: "SAIDA", natureza: "FIXO", cor: "#f59e0b" },
  { nome: "Internet e sistemas", tipo: "SAIDA", natureza: "FIXO", cor: "#0ea5e9" },
  { nome: "Contador", tipo: "SAIDA", natureza: "FIXO", cor: "#8b5cf6" },
  { nome: "Impostos", tipo: "SAIDA", natureza: "VARIAVEL", cor: "#ef4444" },
  { nome: "Materiais e insumos", tipo: "SAIDA", natureza: "VARIAVEL", cor: "#f97316" },
  { nome: "Manutenção de equipamentos", tipo: "SAIDA", natureza: "VARIAVEL", cor: "#64748b" },
  { nome: "Frete", tipo: "SAIDA", natureza: "VARIAVEL", cor: "#a855f7" },
  { nome: "Outras despesas", tipo: "SAIDA", natureza: "VARIAVEL", cor: "#71717a" },
];

/** Categoria das saídas geradas pela compra de estoque. */
export const CATEGORIA_DAS_COMPRAS = "Materiais e insumos";

export const categoriaSalvarSchema = z.object({
  id: z.string().min(1).optional(),
  nome: z.string().trim().min(2, "Dê um nome").max(60),
  tipo: z.enum(TIPOS_FINANCEIROS),
  natureza: z.enum(NATUREZAS),
  cor: z.string().regex(/^#[0-9a-fA-F]{6}$/).nullable().optional(),
});
export type CategoriaSalvarInput = z.infer<typeof categoriaSalvarSchema>;
